import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import {Button} from 'react-bootstrap'
import ListGroup from 'react-bootstrap/ListGroup'
import {Container, Tabs, Tab, Form, ToggleButtonGroup, ToggleButton } from 'react-bootstrap'
import origins from '../assets/origins.json'
import {HorizontalLine} from '../HorizontalLine'
import Modal from 'react-bootstrap/Modal'
import { Radar } from 'react-chartjs-2';
import { FaChartPie } from 'react-icons/fa';

export default function CuppingsScoreForm({singleCupping, singleTable, cuppingNum, cuppingScore, handleDelete}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { register, handleSubmit, setValue, errors } = useForm();
  // eslint-disable-next-line 
  const [validated, setValidated] = useState(false);
  const [customError, thisError] = useState("")
  const [saveOk, setOkMsg] = useState(null)

  const [key, setKey] = useState("core")

  const [oDetails, setDetails] = useState( singleCupping.origin_details || "");
  const [origin] = useState( singleCupping.origin || "");

  const [aFragance, setaFragance] = useState( singleCupping.aroma_fragance || 0);
  const [breakThis] = useState(singleCupping.break || null);
  const [dryThis] = useState( singleCupping.dry || null);

  const [flavor, setFlavor] = useState( singleCupping.flavor || 0);
  const [aftertaste, setAftertaste] = useState( singleCupping.aftertaste || 0);

  const [acidity, setAcidity] = useState( singleCupping.acidity || 0);
  const [acInt] = useState( singleCupping.acidity_intensity || null);

  const [body, setBody] = useState( singleCupping.body || 0);
  const [boInt] = useState( singleCupping.body_intensity || null);
  
  const [roastDetails, setRoast] = useState( singleCupping.roast_details || "");
  const [balance, setBal] = useState( singleCupping.balance || 0);
  const [overall, setOv] = useState( singleCupping.overall || 0);

  const [totalPoints, setTotal] = useState( singleCupping.total_points || null);
  const [defectsTotal, setDefects] = useState( singleCupping.defects_total || 0);
  const [finalTotal, setFinal] = useState( singleCupping.final_score || null);

  const [uniformity, setU] = useState( singleCupping.uniformity || 0);
  const [cleancup, setC] = useState( singleCupping.cleancup || 0);
  const [sweetness, setS] = useState( singleCupping.sweetness || 0);
  const [taint, setTaint] = useState( singleCupping.taint || 0);
  const [fault, setFault] = useState( singleCupping.fault || 0);
  const [taintOrFault, setTf] = useState(singleCupping.taint_or_fault || "");

  const [notes, setNotes] = useState( singleCupping.notes || "");
  const [aromaQualities, setAfQ] = useState( singleCupping.aroma_qualities || "");

  const onSubmit = (data, event, errors) => {
    const form = event.target;
    window.scrollTo(0, 0);

    data.uniformity = uniformity
    data.cleancup = cleancup
    data.sweetness = sweetness

    if (data.origin !== "" && origins.filter(o => o.Country === data.origin).length === 0) {
      setThisError(true, `Origin name ${data.origin} invalid.`)
      setOkMsg(false)
      event.stopPropagation();
      // console.log("Missing Required Fields. ", data, 'Errors', errors);
    } else if (data.aroma_fragance <= 5.75 || data.flavor <= 5.75 || data.aftertaste <= 5.75 || data.acidity <=  5.75 || data.body <= 5.75 || !data.overall || !data.balance || !data.sweetness || !data.uniformity || !data.cleancup) {
      setThisError(true, "Before submitting check for any required score(s) missing.")
      setOkMsg(false)
      event.stopPropagation();
      // console.log("Missing Required Fields. ", data, 'Errors', errors);
    }  
    else if (form.checkValidity() === false) {
      event.stopPropagation();
      // console.log("errors: ");
      console.log("Data E: ", data, 'Errors', errors);
    } else {
        setOkMsg(true)
        setTimeout(() => { setOkMsg(false)}, 4000)
        event.preventDefault();
        thisError(false)
        // console.log("Data OK: ", data);
            data.overall = parseFloat(data.overall)
            data.balance = parseFloat(data.balance)
            data.taint_or_fault = taintOrFault
            data.taint = taint
            data.fault = fault
            data.notes = data.notes.trim()
            data.aroma_fragance = parseFloat(data.aroma_fragance)
            data.flavor = parseFloat(data.flavor)
            data.aftertaste = parseFloat(data.aftertaste)
            data.acidity = parseFloat(data.acidity)
            data.body = parseFloat(data.body)
    
            data.defects_total = defectsTotal
            data.total_points = totalPoints
            data.final_score = finalTotal

        cuppingScore(data)
    }
    // setValidated(true);
  }

  
  const setThisError = (custom, msg) => {
    if (custom) {
      thisError(msg) 
    }
  }

  const handleTaintOrFault = () => {
    if (taintOrFault === "taint") {
      return (
        <React.Fragment>
        <br></br><br></br>
        <ToggleButtonGroup size="md" type="radio" className="scaleBtnNums" defaultValue={taint} 
        onChange={(v) => { calculateDefectsAndTotalPoints(true, v, setTaint)}} 
        name="taint">
          <ToggleButton value={2}>1</ToggleButton>
          <ToggleButton value={2*2}>2</ToggleButton>
          <ToggleButton value={2*3}>3</ToggleButton>
          <ToggleButton value={2*4}>4</ToggleButton>
          <ToggleButton value={2*5}>5</ToggleButton>
        </ToggleButtonGroup>
        </React.Fragment>
      )
    } else if (taintOrFault === "fault") {
      return (
        <React.Fragment><br></br><br></br>
        <ToggleButtonGroup size="md" type="radio" className="scaleBtnNums" defaultValue={fault} 
        onChange={(v) => { calculateDefectsAndTotalPoints(true, v, setFault)}} 
        name="fault">
          <ToggleButton value={4}>1</ToggleButton>
          <ToggleButton value={4*2}>2</ToggleButton>
          <ToggleButton value={4*3}>3</ToggleButton>
          <ToggleButton value={4*4}>4</ToggleButton>
          <ToggleButton value={4*5}>5</ToggleButton>
        </ToggleButtonGroup>
        </React.Fragment>
      )
    }
  }

  const renderScaleBtns = (vertical, refName, value, setAtt) => {
    if (vertical) {
      return (
        <ToggleButtonGroup size="sm" type="radio"  defaultValue={value} className="scaleBtnLines"
        onChange={(value) => { setValue(refName, value)}} 
        name={refName} 
        ref={register({ required: true, name: refName, value: value})}
        vertical
        >
          <ToggleButton name={refName} value={5} ref={register}>━━━━</ToggleButton>
          <ToggleButton name={refName} value={4} ref={register}>───</ToggleButton>
          <ToggleButton name={refName} value={3} ref={register}>━━</ToggleButton>
          <ToggleButton name={refName} value={2} ref={register}>━</ToggleButton>
          <ToggleButton name={refName} value={1} ref={register}><b>-</b></ToggleButton >
      </ToggleButtonGroup>
      )
    } else if (!vertical){
      return (
        <ToggleButtonGroup size="md" type="radio" className="scaleBtnNums" defaultValue={value} 
        onChange={(value) => { handleBaselineChange(value, setAtt)}} 
        onClick={(event) => { handleBaselineChange(event.target.innerText, setAtt)}} 
        name={refName} 
        ref={register({ required: true, name: refName, value: value})}
        >
          <ToggleButton value={2} ref={register}>1</ToggleButton>
          <ToggleButton value={4} ref={register}>2</ToggleButton>
          <ToggleButton value={6} ref={register}>3</ToggleButton>
          <ToggleButton value={8} ref={register}>4</ToggleButton>
          <ToggleButton value={10} ref={register}>5</ToggleButton>
        </ToggleButtonGroup>
      )
    } 
  }

  const handleBaselineChange = (value, setAtt) => {
    if (typeof value == "string" ) {
      let int = parseInt(value)
      int = int * 2
      setAtt(int)
  }  else {
    setAtt(value)
  }
}

  const handleSliderChange = (value, setAttribute) => {
    // const value = e.target.value
    if (value <= 5.75 || value > 9.75) {
      setAttribute(0)
    } else {
      setAttribute(value)
    }
  }


  const renderFixedValuesSlider = (label, refName, inputText, attribute, setAttribute) => {
    return (
      <Form.Group controlId="formBasicRange" className="slideFixedValues">
      <Form.Label>{label}</Form.Label> <br></br><span>{attribute ? attribute : null}</span>
      <input type="range" 
          className="custom-range"
          defaultValue={attribute ? attribute : 0} 
          max={9.75}
          min={5.75} 
          step={0.25}
          onChange={(e) => { handleSliderChange(e.target.value, setAttribute)}} 
          name={refName}
          ref={register({required: true, max: 9.75, min: 6})} /> 
      <Form.Text className="text-muted">
          {inputText ?  inputText : null}
      </Form.Text>
    </Form.Group>
    )
  }

  const calculateDefectsAndTotalPoints = (defects, defectsValue, setAttribute) => {
    const total = parseFloat(aFragance) + parseFloat(flavor) + parseFloat(aftertaste) + parseFloat(acidity) + parseFloat(body) + parseFloat(balance) + parseFloat(overall) + uniformity + cleancup + sweetness

    if (defects && defectsValue && setAttribute) {
      const final = total - defectsValue
      setDefects(defectsValue)
      setAttribute(defectsValue)   
      setFinal(final)
      setTotal(total)
    } else {
      setFinal(total - defectsTotal)
      setTotal(total)
    }
  }

  const renderScoresAsList = (value, nameRef, title, id, setAtt) => {
    return (
        <Form.Group controlId={id} className="scoreCuppingFormEl" >
        <Form.Label>{title} </Form.Label>
          <Form.Control 
          name={nameRef}
          defaultValue={value > 0 ? value : null}
          as="select"
          ref={register({max: 9.75, min: 6})}
          onChange={(e) => setAtt(e.target.value)}
          >
          <option value={value ? value : ""}>{value ? value : "Make a selection" }</option>
          <option>6</option>
              <option>6.25</option><option>6.50</option><option>6.75</option>
          <option>7</option>
              <option>7.25</option><option>6.50</option><option>7.75</option>
          <option>8</option>
              <option>8.25</option><option>8.50</option><option>8.75</option>
          <option>9</option>
              <option>9.25</option><option>9.50</option><option>9.75</option>
          </Form.Control>
        </Form.Group>
    )
  }

  const handleToggleTF = value => {
    if (value === "taint") {
      setFault(0)
      setTf(value)
    } else if (value === "fault") {
      setTaint(0)
      setTf(value)
    } else if (value === "none") {
      setFault(0)
      setTaint(0)
      setDefects(0)
      setTf(value)
    }
  }

  const renderChart = () => {
    if (aFragance > 5.75 && flavor > 5.75 && aftertaste > 5.75 && acidity >  5.75 && body > 5.75 && overall && balance && sweetness && uniformity && cleancup) {
      const data = {
        labels: ['Fragrance/Aroma', 'Flavor', 'Aftertaste', 'Acidity', 'Body', 'Balance'],
        datasets: [{
          // backgroundColor: "#faebd7",
          data: [parseFloat(aFragance), parseFloat(flavor), parseFloat(aftertaste), parseFloat(acidity), parseFloat(body), parseFloat(balance)],
        }]
      }
      return (
        <Tab eventKey="chart" title={<FaChartPie/>} > <br></br>
            <Radar
                  data={data}
                  // width={100}
                  // height={50}
                  options={{            
                    scale: {
                      ticks: {
                        min: 6,
                        max: 10
                    }
                },
                legend: {
                  display: false,
                },
                responsive: true,
                maintainAspectRatio: true, 
                title: {
                  display: true,
                  text: `Final Score: ${finalTotal}`
              }
          }}/>  <br></br>
       </Tab>
       )
     }
    }

    const renderDelete = () => {

      if (singleTable.num_coffees > 1) {
        return (
          <>
        <Button variant="outline-danger" size="sm" onClick={handleShow} style={{margin: "0 auto", display: "block", border: "none"}}>Delete this cupping</Button>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
                <Modal.Body>This is permanent. <b>You will loose all saved scores</b>.</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="danger" onClick={handleDelete}>Confirm</Button>
            </Modal.Footer>
        </Modal></> 
        )}      
    }

  return (
    // begin return
    <Container>
        <div><h5 className="styleHeading w3-center" style={{color: "#483730"}}> 
            {singleTable.origin? `#${cuppingNum + 1} Cupping: ${singleTable.origin}` : `#${cuppingNum + 1} Cupping`} 
          </h5>&nbsp; 
        <h6 className="styleHeading tableNameMobile w3-center" style={{color: "#483730"}}>
            {singleTable.name} Table </h6></div>
        <h4 className="tableNameMobile w3-center"> <b><span style={{color: "coral"}}>Final Score: </span> {finalTotal ? finalTotal : "TBD" } </b></h4>
        <div className="w3-center"><small>Total Points:  <b> {totalPoints ? totalPoints : "TBD"} </b>  |   Defects:  <span> {defectsTotal ? defectsTotal : 0}  </span> </small></div>
        <div className="w3-center"><small style={{color: "crimson"}}>{customError ? customError : null}</small></div>
        <div className="w3-center w3-animate-fading"><small style={{color: "forestgreen"}}>{saveOk ? "Changes Saved!" : null} </small></div>
        <br></br>
        {/* END headings */}
     <Form onSubmit={handleSubmit(onSubmit)} validated={validated} noValidate className="tableForm scoreCuppingTabs" onBlur={() => calculateDefectsAndTotalPoints()} onFocus={() => calculateDefectsAndTotalPoints()}> 
        <Tabs defaultActiveKey="core" id="scoreCuppingTabs" activeKey={key} onSelect={k => setKey(k)}>            
          <Tab eventKey="core" title="Core"> <br></br>
            <Container className="basicC" style={{textAlign: "center"}}>
            <Form.Group controlId="formControlsSelect" className="scoreCuppingFormEl" style={{margin: "0 auto"}}>
              <Form.Label>Origin</Form.Label>
                <Form.Control 
                name="origin"
                as="select"
                placeholder="select"
                ref={register} >
                <option value={origin}>{origin ? origin : "Make a selection" }</option>
                {origins.map((data, index) => 
                    <option key={index} value={data.Country}> {data.Country}</option>
                  )}
                </Form.Control>
              </Form.Group><br></br>
              <Form.Group controlId="ControlTextareaO" className="scoreCuppingOd" style={{margin: "0 auto"}}>
                <Form.Label>Origin Description</Form.Label>
                <Form.Control as="textarea" value={oDetails} onBlur={e => setDetails(e.target.value.trim())} onChange={e => setDetails(e.target.value)} rows="2" maxLength="300" placeholder="Enter Description" name="origin_details" ref={register({ maxLength: 301})} />
                    <span className="invalid">
                    {errors.origin_details && errors.origin_details.type === "maxLength" && "Please make sure description is no more than 300 characters."}
                    </span> 
              </Form.Group> <br></br>     

              {renderFixedValuesSlider("Aroma/Fragance", "aroma_fragance", null, aFragance, setaFragance)}
                <small>Dry</small>
                {renderScaleBtns(true, "dry", dryThis)}
                <small>Break</small>
                {renderScaleBtns(true, "break", breakThis)}<br></br> 
                   
              <br></br>{renderFixedValuesSlider("Flavor", "flavor", null, flavor, setFlavor)}
              {renderFixedValuesSlider("Aftertaste", "aftertaste", null, aftertaste, setAftertaste)}

              {renderFixedValuesSlider("Acidity", "acidity", null, acidity, setAcidity)}
                <div className="scIntensity" >
                  {renderScaleBtns(true, "acidity_intensity", acInt)}
                  <small>Intensity</small>
                </div>
              
              <br></br>{renderFixedValuesSlider("Body", "body", null, body, setBody)}
                <div className="scIntensity" >
                  {renderScaleBtns(true, "body_intensity", boInt)}
                  <small>Level</small>
                </div>
                <HorizontalLine color="light-grey" />    
                {/* END BASIC TAB */}
                <Container><Button variant="primary" size="md" onClick={()=> setKey("general")} style={{display: "block"}}>Next</Button> </Container><br></br>

          </Container>
          </Tab>
                <Tab eventKey="general" title="General"> <br></br>
                        <ListGroup variant="flush">
                            <ListGroup.Item className="cShowList">
                              {renderScoresAsList(balance, "balance", "Balance: ", "balanceSelect", setBal)}
                            </ListGroup.Item>
                            <ListGroup.Item className="cShowList">
                              {renderScoresAsList(overall, "overall", "Overall: ", "overallSelect", setOv)}
                            </ListGroup.Item>                            
                        </ListGroup> <br></br>
                        <Container><Button variant="primary" size="md" onClick={()=> setKey("core")} style={{margin: "0 auto", display: "inline"}}>Back</Button> &nbsp;
                        <Button variant="primary" size="md" onClick={()=> setKey("baseline")} style={{margin: "0 auto", display: "inline"}}>Next</Button></Container><br></br>    
                    </Tab>
                    <Tab eventKey="baseline" title="Baseline"> <br></br>
                        <ListGroup variant="flush">
                            <ListGroup.Item className="cShowList"> 
                              <Form.Label>Uniformity:  </Form.Label>&nbsp;&nbsp;
                              {renderScaleBtns(false, "uniformity", uniformity, setU)}
                            </ListGroup.Item>
                            <ListGroup.Item className="cShowList">
                                <Form.Label>Clean Cup:  </Form.Label> &nbsp;&nbsp;
                              {renderScaleBtns(false, "cleancup", cleancup, setC)}
                            </ListGroup.Item>
                            <ListGroup.Item className="cShowList">
                                <Form.Label>Sweetness:  </Form.Label>&nbsp;&nbsp;
                                {renderScaleBtns(false, "sweetness", sweetness, setS)}
                            </ListGroup.Item>                          
                            <ListGroup.Item className="cShowList">
                            <ToggleButtonGroup size="sm" type="radio" className="scaleBtnNums" defaultValue={taintOrFault} 
                                onChange={(value) => { handleToggleTF(value)}} 
                                name="taint_or_fault" >
                                  <ToggleButton value={"taint"} >Taint</ToggleButton>
                                  <ToggleButton value={"fault"} >Fault</ToggleButton>
                                  <ToggleButton value={"none"} >None</ToggleButton>
                              </ToggleButtonGroup> &nbsp;
                              {handleTaintOrFault()}
                            </ListGroup.Item>
                        </ListGroup><br></br>
                        <Container><Button variant="primary" size="md" onClick={()=> setKey("general")} style={{margin: "0 auto", display: "inline"}}>Back</Button> &nbsp;
                        <Button variant="primary" size="md" onClick={()=> setKey("review")} style={{margin: "0 auto", display: "inline"}}>Next</Button></Container><br></br> 
                    </Tab> 

                    <Tab eventKey="review" title="Review"> <br></br>
                    <Form.Group controlId="AFQTextarea" className="scoreCuppingOd" style={{margin: "0 auto"}}>
                      <Form.Label>Aroma/Fragance Qualities</Form.Label>
                      <Form.Control as="textarea" value={aromaQualities} onBlur={e => setAfQ(e.target.value.trim())}
                      onChange={e => setAfQ(e.target.value)} rows="2" maxLength="300" placeholder="Describe Aroma/Fragance Qualities" name="aroma_qualities" ref={register({ maxLength: 301})} />
                          <span className="invalid">
                          {errors.aroma_qualities && errors.aroma_qualities.type === "maxLength" && "Please make sure text is no more than 300 characters."}
                          </span> 
                    </Form.Group> <br></br>
                    <Form.Group controlId="RoastTextarea" className="scoreCuppingOd" style={{margin: "0 auto"}}>
                      <Form.Label>Roast Details</Form.Label>
                      <Form.Control as="textarea" value={roastDetails} onBlur={e => setRoast(e.target.value.trim())} onChange={e => setRoast(e.target.value)} rows="2" maxLength="300" placeholder="Add Roast Details" name="roast_details" ref={register({ maxLength: 301})} />
                          <span className="invalid">
                          {errors.roast_details && errors.roast_details.type === "maxLength" && "Please make sure text is no more than 300 characters."}
                          </span> 
                    </Form.Group><br></br>
                    <Form.Group controlId="NotesTextarea" className="scoreCuppingOd" style={{margin: "0 auto"}}>
                      <Form.Label>Additional Notes</Form.Label>
                      <Form.Control as="textarea" value={notes} onBlur={e => setNotes(e.target.value.trim())} onChange={e => setNotes(e.target.value)} rows="2" maxLength="300" placeholder="Additional Notes Here" name="notes" ref={register({ maxLength: 301})} />
                          <span className="invalid">
                          {errors.notes && errors.notes.type === "maxLength" && "Please make sure text is no more than 300 characters."}
                          </span> 
                    </Form.Group>        
                <br></br><br></br><Button variant="primary" size="lg" type="submit" style={{margin: "0 auto", display: "block"}}>Save</Button>              
                    </Tab>
                    {renderChart()}
                </Tabs>
                <div className="w3-center w3-animate-fading animate"><small><i> Save scores at the end to confirm changes. </i></small></div>
                  {renderDelete()}
    
       </Form>
   </Container>
  );
}